module.exports = {
  presentationApp: {
    labels: {
      video: "Видео",
      file: "Файл",
      fileTemplate: "Шаблон файла",
      openMedia: "Открыть в полноэкранном просмотре",
      closeMedia: "Закрыть просмотр",
      fullscreenPreview: "Полноэкранный просмотр"
    },
    cover: {
      kicker: "SMART-TEAM-DEV-PORTAL",
      title: "Корпоративный портал",
      lead: "Веб-платформа для централизованного доступа к корпоративным приложениям, данным и сервисам.",
      note:
        "Объединяет документооборот, финансовые модули, банковские API, СКУД, лабораторный учёт, транспортный мониторинг и ИИ-ассистента. Развёртывается на собственной инфраструктуре.",
      alt: "Главный экран корпоративного портала",
      video: "обзор главного экрана и рабочих модулей портала"
    },
    about: {
      kicker: "Платформа",
      title: "Node.js-платформа с модульной архитектурой",
      lead:
        "Серверная часть — Node.js, фронтенд — React/Webpack. Каждый раздел — самостоятельный модуль с собственной бизнес-логикой, маршрутизацией и API. Более 30 приложений в единой оболочке.",
      items: [
        "модульная структура: каждое приложение независимо",
        "ролевое разграничение доступа через AD-группы",
        "REST API для интеграций с внешними системами",
        "TypeScript-типизация, единая кодовая база"
      ],
      primaryAlt: "Архитектура корпоративного портала",
      secondaryAlt: "Рабочее пространство пользователя",
      mediaCaption: "",
      video: ""
    },
    roles: {
      kicker: "Доступ",
      title: "Ролевая модель на основе AD-групп",
      lead:
        "Набор доступных приложений и данных определяется ролью пользователя, привязанной к Active Directory. Управление ролями централизовано, не требует изменений в коде.",
      keyTitle: "",
      items: [
        "руководители",
        "офисные сотрудники",
        "инженеры и технические специалисты",
        "бухгалтерия",
        "кадровые службы",
        "ИТ-администраторы",
        "внешние пользователи"
      ],
      mediaAlt: "Ролевая модель и доступ пользователей",
      mediaCaption: "",
      video: "пример разграничения доступа по ролям"
    },
    tasks: {
      kicker: "Функциональность",
      title: "Задачи, закрываемые платформой",
      lead:
        "Платформа охватывает ключевые рабочие процессы: документооборот, финансовый учёт, банковские операции, лабораторные данные, мониторинг и автоматизацию.",
      items: [
        "управление доступом (AD, RBAC)",
        "делопроизводство и документооборот",
        "банковские операции и выписки",
        "лабораторные модули и НТД",
        "СКУД и учёт рабочего времени",
        "транспорт и телеметрия (FortMonitor)",
        "ИИ-ассистент на базе OpenAI API",
        "аудит и системное логирование"
      ],
      mediaAlt: "Экосистема корпоративного портала",
      mediaCaption: "Фото: экосистема портала и ключевые направления работы",
      video: "короткий проход по основным процессам"
    },
    workflow: {
      kicker: "Сценарий работы",
      title: "Типовой пользовательский путь",
      lead:
        "Все модули следуют единой навигационной модели. Пользователь авторизуется один раз и получает доступ ко всем разрешённым приложениям без повторного входа.",
      steps: [
        { title: "авторизация", text: "Вход через AD или встроенную систему аутентификации." },
        { title: "рабочий стол", text: "Список доступных модулей, уведомления, виджеты." },
        { title: "модуль", text: "Переход в нужное приложение по иконке или прямой ссылке." },
        { title: "операция", text: "Работа с данными: документ, форма, карточка, таблица." },
        { title: "результат", text: "Статус, уведомление, отчёт, файл или запись в системе." }
      ],
      mediaAlt: "Сценарий выбора приложения в портале",
      mediaCaption: "Фото: переход от рабочего стола к приложению",
      video: "пользовательский путь от входа до результата",
      lineTitle: "Типовой сценарий:",
      lineText: "авторизация → рабочий стол → модуль → операция → результат"
    },
    desktop: {
      kicker: "Рабочий стол",
      title: "Настраиваемый стартовый экран",
      lead:
        "Состав иконок, виджетов и разделов формируется на основе роли пользователя. Персонализация не требует изменений на сервере — конфигурируется через настройки профиля.",
      items: [
        "персональный набор иконок и быстрых ссылок",
        "виджеты с актуальными данными",
        "адаптация под роль и подразделение",
        "минимальное число шагов до нужной функции"
      ],
      alt: "Единый цифровой рабочий стол портала",
      video: "настройка рабочего стола под роль пользователя"
    },
    modules: [
      {
        id: "paperwork",
        number: "07",
        kicker: "Документооборот",
        title: "Документы, карточки, вложения",
        lead:
          "Единый интерфейс для создания, хранения и работы с внутренними документами. Поддерживается связка с карточками контрагентов, сотрудников и договоров, совместное редактирование через Office Online.",
        bullets: [
          "создание и редактирование документов",
          "хранение вложений в файловом хранилище",
          "совместное редактирование (Office Online)",
          "связи: документ — контрагент — договор"
        ],
        image: "/img/presentation_app/logo_docs.png",
        alt: "Раздел документов и делопроизводства",
        caption: "Фото: раздел делопроизводства и карточки документов",
        file: "/img/presentation_app/logo_docs.png",
        video: "работа с карточкой, вложениями и связанными данными"
      },
      {
        id: "contragents",
        number: "08",
        kicker: "Контрагенты",
        title: "Карточки партнёров с внешними проверками",
        lead:
          "Интеграция с Контур.Фокус и DaData: автозаполнение реквизитов по ИНН, проверка надёжности контрагента, отслеживание изменений юридического статуса.",
        bullets: [
          "автозаполнение реквизитов по ИНН (DaData API)",
          "проверка по базе Контур.Фокус",
          "уведомления об изменении статуса",
          "связка с документами и банковскими операциями"
        ],
        image: "/img/presentation_app/logo_agents.png",
        alt: "Карточка контрагента и контактные данные",
        caption: "Фото: карточка контрагента, реквизиты и статусы",
        file: "/img/presentation_app/logo_agents.png",
        video: "проверка реквизитов и обновление карточки партнера"
      },
      {
        id: "finance",
        number: "09",
        kicker: "Финансы и банки",
        title: "Банковские выписки и интеграция с 1С",
        lead:
          "Импорт выписок через API Сбербанка, Тинькофф, ВТБ, Точки, Альфа-Банка. Автоматическое сопоставление операций с контрагентами и договорами, выгрузка в формате 1С.",
        bullets: [
          "подключение к API нескольких банков",
          "автоматический импорт и разбор выписок",
          "сопоставление платежей с контрагентами",
          "выгрузка данных в формате 1С"
        ],
        image: "/img/presentation_app/logo_finance.png",
        alt: "Финансовый раздел портала",
        caption: "Фото: журнал платежей и статусы обработки",
        file: "/img/presentation_app/logo_finance.png",
        video: "импорт операций, сверка и переход к связанным данным"
      },
      {
        id: "laboratory",
        number: "10",
        kicker: "Лабораторные модули",
        title: "Учёт оборудования, методик и отчётов",
        lead:
          "Профильный блок для лабораторной деятельности: справочники НТД, учёт оборудования и техгрупп, шаблоны документов Word/Excel, сертификаты и допуски сотрудников.",
        bullets: [
          "справочники НТД и методик",
          "учёт оборудования и техгрупп",
          "шаблоны отчётов (Word/Excel)",
          "сертификаты и допуски сотрудников"
        ],
        image: "/img/presentation_app/logo_lab.png",
        alt: "Лабораторный модуль портала",
        caption: "Фото: оборудование, методики и шаблоны отчетов",
        file: "/img/presentation_app/logo_lab.png",
        video: "путь от объекта испытаний до готового отчета"
      },
      {
        id: "skud",
        number: "11",
        kicker: "СКУД",
        title: "Интеграция с системой контроля доступа",
        lead:
          "Автоматический сбор событий из СКУД: проходы, смены, опоздания. Данные обрабатываются на сервере, формируются отчёты по посещаемости и нарушениям.",
        bullets: [
          "импорт событий прохода из СКУД",
          "учёт смен и фиксация опозданий",
          "отчёты по посещаемости и нарушениям",
          "связка с кадровыми данными"
        ],
        image: "/img/presentation_app/logo_skud.png",
        alt: "Модуль СКУД и учета рабочего времени",
        caption: "Фото: журнал проходов и аналитика посещаемости",
        file: "/img/presentation_app/logo_skud.png",
        video: "разбор события прохода, смены и отчета по посещаемости"
      },
      {
        id: "transport",
        number: "12",
        kicker: "Транспорт",
        title: "Путевые листы и телеметрия FortMonitor",
        lead:
          "Цифровой учёт транспортных операций: путевые листы, маршруты, пробег. Данные сопоставляются с телеметрией из API FortMonitor.",
        bullets: [
          "учёт автомобилей и путевых листов",
          "маршруты и контроль пробега",
          "телеметрия из API FortMonitor",
          "сверка документов с фактическим движением"
        ],
        image: "/img/presentation_app/logo_car.png",
        alt: "Транспортный мониторинг и движение",
        caption: "Фото: транспорт, маршруты и промышленный мониторинг",
        file: "/img/presentation_app/logo_car.png",
        video: "сопоставление путевого листа с пробегом и маршрутом"
      },
      {
        id: "ai",
        number: "13",
        kicker: "ИИ-ассистент",
        title: "Встроенный чат на базе OpenAI API",
        lead:
          "Интеграция с OpenAI (GPT-4): анализ загруженных файлов, системных журналов, ответы на вопросы по корпоративным данным на естественном языке.",
        bullets: [
          "подключение к OpenAI Chat Completions API",
          "анализ загружаемых файлов и документов",
          "разбор системных журналов и логов",
          "контекстный поиск по корпоративным данным"
        ],
        image: "/img/presentation_app/logo_ai.png",
        alt: "Интерфейс ИИ-ассистента",
        caption: "Фото: пример запроса и ответа ИИ-ассистента",
        file: "/img/presentation_app/logo_ai.png",
        video: "анализ файла, журнала или пользовательского вопроса"
      },
      {
        id: "security",
        number: "15",
        kicker: "Безопасность",
        title: "Аутентификация, роли и аудит",
        lead:
          "Аутентификация через Active Directory (LDAP), ролевое разграничение на уровне приложений и данных (RBAC), полный журнал действий пользователей.",
        bullets: [
          "интеграция с Active Directory (LDAP)",
          "ролевое управление доступом (RBAC)",
          "журнал аудита всех значимых операций",
          "разграничение видимости данных по роли"
        ],
        image: "/img/presentation_app/dark_access.png",
        alt: "Роли, AD-группы и персональный рабочий стол портала",
        caption: "Фото: роли, AD-группы и правила доступа",
        file: "/img/presentation_app/dark_access.png",
        video: "выдача роли, проверка прав и просмотр журнала аудита"
      },
      {
        id: "automation",
        number: "16",
        kicker: "Автоматизация",
        title: "Фоновые задачи и межсистемные интеграции",
        lead:
          "Планировщик фоновых задач для регулярных операций: синхронизация данных, проверки, рассылки. Интеграции реализованы через REST API и SOAP.",
        bullets: [
          "планировщик фоновых задач (cron-задачи)",
          "интеграции через REST API и SOAP",
          "уведомления: email, Telegram, WhatsApp",
          "синхронизация с AD, 1С, банками"
        ],
        integrations: ["AD", "1С", "банки", "Контур.Фокус", "DaData", "почта", "мессенджеры", "СКУД", "FortMonitor", "OpenAI"],
        image: "/img/presentation_app/dark_Integration.png",
        alt: "Интеграции корпоративных сервисов портала",
        caption: "Фото: внешние сервисы и интеграции корпоративного портала",
        file: "/img/presentation_app/dark_Integration.png",
        video: "синхронизация, проверки, рассылки и обновление данных"
      }
    ],
    value: {
      kicker: "Итог",
      title: "Что даёт платформа",
      lead:
        "Централизованная платформа сокращает количество разрозненных инструментов, стандартизирует процессы и снижает операционные издержки.",
      groups: [
        {
          title: "Для пользователей",
          bullets: [
            "единый интерфейс вместо набора отдельных систем",
            "меньше ручных и повторяющихся операций",
            "быстрый доступ к нужным данным",
            "уведомления и статусы в реальном времени"
          ]
        },
        {
          title: "Для ИТ и бизнеса",
          bullets: [
            "централизованное управление доступом",
            "прозрачность процессов через аудит",
            "единая кодовая база для всех модулей",
            "готовая основа для новых приложений"
          ]
        }
      ],
      assetTitle: "Иконки выгод",
      assetText: "без обязательного скриншота",
      image: "/img/presentation_app/dark_value.png",
      imageAlt: "Практическая ценность для пользователя и компании",
      imageCaption: "Фото: практическая ценность портала для пользователя и компании",
      video: "короткий итог по ценности для пользователя и компании"
    },
    conclusion: {
      kicker: "Платформа",
      title: "Масштабируемая корпоративная система",
      lead:
        "Более 30 модулей, 10+ интеграций с внешними сервисами, развёртывание на собственной инфраструктуре. Архитектура допускает добавление новых приложений без изменения ядра.",
      bullets: [
        "единый интерфейс для всех подразделений",
        "модульная архитектура без жёсткой связанности",
        "интеграции: AD, 1С, банки, СКУД, OpenAI",
        "аудит, логирование, ролевой контроль доступа",
        "документированный API для новых интеграций"
      ],
      alt: "Главный экран корпоративного портала",
      file: "/img/presentation_app/dark_portal.png",
      video: "финальный проход по ключевым возможностям портала"
    }
  }
};
